import React, { Component } from "react";
import Select from "react-select";


const tipoPresentacion = {
  select: "SELECT",
  tabla: "TABLA"
};

export default class CuentasDebito extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: this.props.itemSelected,
      opcion: [],
      options: this.props.cuentas
    };
  }

  componentDidMount() {
   
  }

  getInitialState = () => ({
    selectedOption: this.props.itemSelected,
      opcion: [],
      options: this.props.cuentas
  }); 

  resetState = () => {
    this.setState(this.getInitialState());
   // console.log("Resetea estado")
    //console.log(this.state.selectedOption)
    
  };
 
  handleChangeSelector = (selectedOption) => {
    
    if (selectedOption == null)
      this.props.selectorValue(undefined, undefined);
    else
      this.props.selectorValue(selectedOption.value, selectedOption);
  };

  obtenerCuentas() {
    switch (this.props.presentacion) {
      case tipoPresentacion.select:
        return (
          <div className="form-group">
            <label className="input-label-bold">{this.props.titulo} *</label>
            <div className="is-invalid" id="prueba">
            <Select id="tipo" name="tipo"
              defaultValue={this.props.itemSelected}
              onChange={this.handleChangeSelector}
              placeholder="-- seleccione --"
              options={this.props.cuentas}
              isClearable
              noOptionsMessage={() => 'SIN DATOS'}
            />   
            </div>          
          </div>
        );
      case tipoPresentacion.tabla:
          break;
    }       
  }

  render() {
    const { selectedOption } = this.state;
    return (
      <div>
        <div className="form-group">
          {this.obtenerCuentas()}
        </div>
      </div>
    );
  }
}
